<script>
export default {
    name: "IconAngleLeft"
}
</script>

<template>
    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
         fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 19-7-7 7-7"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
